import type { ChartLayout } from "../renderers/layout";

export function barWidth(layout: ChartLayout, start: number, end: number): number {
  const count = Math.max(1, end - start + 1);
  return layout.plotWidth / count;
}

export function xForIndex(layout: ChartLayout, start: number, end: number, index: number): number {
  return layout.left + (index - start + 0.5) * barWidth(layout, start, end);
}

export function indexFromX(layout: ChartLayout, start: number, end: number, x: number): number {
  const raw = start + Math.floor((x - layout.left) / Math.max(1, barWidth(layout, start, end)));
  return clamp(raw, start, end);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
